import React from "react";
import MotionReveal from "./MotionReveal";
import HomeSectionHeading from "./HomeSectionHeading";

export default function HomeMission({ content }) {
  return (
    <section className="public-home-premium__section public-home-premium__section--editorial public-home-premium__section--mission-stage" id="mission">
      <div className="public-home-premium__mission-ambient" aria-hidden="true">
        <span className="public-home-premium__mission-orbit public-home-premium__mission-orbit--one" />
        <span className="public-home-premium__mission-orbit public-home-premium__mission-orbit--two" />
        <span className="public-home-premium__mission-orbit public-home-premium__mission-orbit--three" />
        <span className="public-home-premium__mission-rail public-home-premium__mission-rail--one" />
        <span className="public-home-premium__mission-rail public-home-premium__mission-rail--two" />
        <span className="public-home-premium__mission-node public-home-premium__mission-node--one" />
        <span className="public-home-premium__mission-node public-home-premium__mission-node--two" />
        <span className="public-home-premium__mission-node public-home-premium__mission-node--three" />
      </div>
      <div className="mx-auto grid w-full max-w-page gap-8 px-4 sm:px-6 lg:grid-cols-[minmax(0,0.92fr)_minmax(320px,0.58fr)] lg:px-8">
        <MotionReveal>
          <div className="public-home-premium__mission-copy">
            <HomeSectionHeading eyebrow={content.eyebrow} title={content.title} lead={content.lead} tone="inverse" className="max-w-none" />

            <div className="public-home-premium__mission-body">
              {(content.paragraphs || []).map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>

            {content.quote ? (
              <blockquote className="public-home-premium__mission-quote">
                {content.quote}
              </blockquote>
            ) : null}
          </div>
        </MotionReveal>

        <MotionReveal delay={0.08}>
          <aside className="public-home-premium__mission-side">
            <section className="public-home-premium__mission-aside">
              <span className="public-home-premium__mini-label">Prinzipien</span>
              <h3>Systemische Leitlinien</h3>
              <div className="public-home-premium__principle-grid">
                {(content.principles || []).map((principle) => (
                  <span key={principle}>{principle}</span>
                ))}
              </div>
            </section>

            {content.antipatterns?.length ? (
              <section className="public-home-premium__mission-boundary-panel">
                <span className="public-home-premium__mini-label">Was wir nicht tun</span>
                <ul className="public-home-premium__mission-boundary-list">
                  {content.antipatterns.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </section>
            ) : null}
          </aside>
        </MotionReveal>
      </div>
    </section>
  );
}
